// extracted by mini-css-extract-plugin
export default {"roof_container_mb":"RoofMobile_roof_container_mb__PvO4E","roof_mb":"RoofMobile_roof_mb__0xoJo","pp_button_lottie":"RoofMobile_pp_button_lottie__Zmk3i"};